import { useNotificationStore } from './store';
import { BLUE_COLOR, GREEN_COLOR, ORANGE_COLOR, RED_COLOR } from '@/components/theme';
import { alpha, darken } from '@mui/material/styles';
import MuiSnackbar from '@mui/material/Snackbar';
import Slide, { SlideProps } from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const COLOR_MAP = {
  success: GREEN_COLOR,
  error: RED_COLOR,
  warning: ORANGE_COLOR,
  info: BLUE_COLOR,
} as const;

export default function Banner() {
  const { notification, handleClose } = useNotificationStore();

  if (notification.type !== 'banner') return null;

  const color = COLOR_MAP[notification.severity as keyof typeof COLOR_MAP] || GREEN_COLOR;

  return (
    <MuiSnackbar
      open={notification.open}
      autoHideDuration={6000}
      onClose={handleClose}
      key={notification.message}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ width: '110%', top: 0, mx: '-5%' }}
      slots={{ transition: Slide }}
      slotProps={{ transition: { direction: 'down' } as SlideProps }}
    >
      <Paper
        elevation={3}
        sx={{
          mt: '40px',
          width: '100%',
          borderRadius: '0 0 var(--mui-shape-borderRadius) var(--mui-shape-borderRadius)',
          overflow: 'hidden',
          color: darken(color, 0.2),
          bgcolor: alpha(color, 0.2),
          backdropFilter: 'blur(4px)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            maxWidth: 'sm',
            mx: 'auto',
            width: '100%',
            alignItems: 'center',
            py: 1,
          }}
        >
          {notification.mode === 'loading' && (
            <CircularProgress size={20} color='inherit' sx={{ mr: 2 }} />
          )}

          <Box sx={{ flex: 1 }}>
            {notification.title && (
              <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
                {notification.title}
              </Typography>
            )}
            <Typography variant='body2'>{notification.message}</Typography>
          </Box>

          <IconButton size='small' color='inherit' onClick={handleClose} sx={{ ml: 1 }}>
            <CloseIcon fontSize='small' />
          </IconButton>
        </Box>
      </Paper>
    </MuiSnackbar>
  );
}
